/**
 * Google Analytics 4 — SPA helpers.
 *
 * The gtag.js snippet is loaded once in /public/index.html with
 *   gtag('config', 'G-ZC8LBCTKF0', { send_page_view: false });
 * so the initial pageview does NOT fire automatically. Instead we fire it from
 * React Router on every route change via <RouteTracker /> mounted in App.js.
 *
 * For custom conversion events use trackEvent() from anywhere in the app.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const GA_MEASUREMENT_ID = "G-ZC8LBCTKF0";

const hasGtag = () => typeof window !== "undefined" && typeof window.gtag === "function";

/**
 * Fire a GA4 `page_view` for the current location. Called on every route change.
 */
export function trackPageView(pathname, search = "") {
  if (!hasGtag()) return;
  window.gtag("event", "page_view", {
    page_path: pathname + (search || ""),
    page_location: window.location.href,
    page_title: document.title,
  });
}

/**
 * Fire a custom event. Use the GA4 recommended names where possible:
 *   sign_up, login, begin_checkout, purchase, generate_lead, share, etc.
 * https://developers.google.com/analytics/devguides/collection/ga4/reference/events
 */
export function trackEvent(name, params = {}) {
  if (!hasGtag()) return;
  window.gtag("event", name, params);
}

/**
 * Mount once at the top of <BrowserRouter>. Fires page_view on every route change.
 */
export function RouteTracker() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    trackPageView(pathname, search);
  }, [pathname, search]);
  return null;
}
